import { createContext, Dispatch, SetStateAction } from 'react'
import { EOperatorTypes } from '@cakemail-org/ui-components-v2'
import { TDashboardContext } from './types'

export const DashboardContext = createContext<TDashboardContext>({

})